import React, { useState } from "react";
import { experience } from "./ExperienceData";
import { ExArticle } from "./ExArticle";
import { StyledTitle } from "../../Styled-component/StyledTitle";
import { ReviewMain } from "./Review/ReviewMain";
import "./Experience.css";

export const Experience = () => {
  const [data] = useState(experience);
  const [value, setValue] = useState(0);
  return (
    <div className="experience">
      <StyledTitle title="My Experience" />
      <main data-aos="fade-up" className="arMain">
        <section className="btn-container-ex">
          {data.map((singleData, index) => {
            return (
              <button
                key={singleData.id}
                onClick={() => setValue(index)}
                className={`btnEx ${index === value && "active-btn-ex"}`}
              >
                {singleData.company}
              </button>
            );
          })}
        </section>
        <ExArticle data={data} value={value} />
      </main>
      <ReviewMain />
    </div>
  );
};
